// * Bootstrap libraries
import "./_bootstrap";

document.querySelectorAll('#page-heading').forEach((element, i) => {
  if (i > 0) {
    element.style.display = 'none';
  }
});

document.querySelectorAll('.nav-tabs').forEach((element, i) => {
  if (i > 0) {
    element.style.display = 'none';
  }
});
